/* Melissa TR — mel-donusum.js (NEW41 taslak). Ayarlar ve ürün verisi snippets/mel-donusum.liquid içinde. */
(function(){
  if (window.__melDonusum) return; window.__melDonusum = true;
  var KOK = (function(){ var m = location.pathname.match(/^\/(en|pt|pt-br)(\/|$)/i); return m ? '/' + m[1] : ''; })();
  var DIL = KOK ? KOK.slice(1,3).toLowerCase() : 'tr';
  var AYAR = window.MEL_AYAR || {};
  var M = {
    tr: { pesin: 'Peşin fiyatına', aylik: 'aylık', tk3: 'Peşin fiyatına 3 taksit' },
    en: { pesin: '3 interest-free installments of', aylik: 'per month', tk3: '3 interest-free installments' },
    pt: { pesin: '3x sem juros de', aylik: 'por mês', tk3: '3x sem juros' }
  }[DIL] || null;

  var RENK = ['renk', 'color', 'cor', 'colour'];
  /* ---------- yardımcılar ---------- */
  function sayi(t){ var s = String(t || '').replace(/[^\d,]/g, '').replace(',', '.'); var n = parseFloat(s); return isNaN(n) ? 0 : n; }
  function tl(n){ return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
  function ucte(n){ return Math.round(n / 3 * 100) / 100; }
  function el(tag, cls, html){ var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function kes(s){ return String(s || '').replace(/[<>"]/g, ''); }
  function gorsel(u, w){ if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300); }
  function taban(u){ var p = String(u).split('?')[0].split('#')[0].split('/'); var h = p[p.length - 1] || ''; var g = h.split('-'); if (g.length > 1) g.pop(); return g.join('-'); }
  function tutucu(fn, ms){ var z; return function(){ clearTimeout(z); z = setTimeout(fn, ms || 150); }; }
  var jsOnbellek = {};
  function urunJs(handle){ if (!jsOnbellek[handle]) jsOnbellek[handle] = fetch(KOK + '/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); return jsOnbellek[handle]; }
  var araOnbellek = {};
  function ara(baslik){ if (!araOnbellek[baslik]) araOnbellek[baslik] = fetch(KOK + '/search/suggest.json?q=' + encodeURIComponent('"' + baslik + '"') + '&resources[type]=product&resources[limit]=10').then(function(r){ return r.json(); }).then(function(d){ return (d.resources && d.resources.results && d.resources.results.products) || []; }).catch(function(){ return []; }); return araOnbellek[baslik]; }
  function biOf(p){ var o = (p && p.options) || []; for (var i = 0; i < o.length; i++){ var n = String(o[i] && o[i].name ? o[i].name : o[i]).toLowerCase(); if (RENK.indexOf(n) < 0) return i; } return 0; }
  function hdl(u){ return String(u).split('?')[0].split('/products/').pop(); }
  function hedefBaslik(t){ t = String(t || '').trim(); if (/^MINI MELISSA /i.test(t)) return t.replace(/^MINI /i, ''); if (/^MELISSA /i.test(t)) return 'MINI ' + t; return null; }

  /* ---------- 4) Klaviyo: Added to Cart ----------
     Tema/uygulamalar fetch'i sardığı için ağ isteği dinlenmez. Sepet değiştiğinde /cart.js okunur,
     adedi artan satır "Added to Cart" olarak Klaviyo'ya gönderilir. Sayfa açılışındaki sepet taban kabul edilir. */
  var kTaban = null, kMesgul = false;
  function sepetOku(){ return fetch(KOK + '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); }
  function klaviyoIzle(){
    if (kMesgul) return; kMesgul = true;
    sepetOku().then(function(c){
      kMesgul = false;
      var harita = {}; (c.items || []).forEach(function(i){ harita[i.key] = i.quantity; });
      if (kTaban === null){ kTaban = harita; return; }
      var yeni = null;
      (c.items || []).forEach(function(i){ if (!yeni && i.quantity > (kTaban[i.key] || 0)) yeni = i; });
      kTaban = harita;
      if (!yeni) return;
      var o = location.origin, s = yeni;
      var ozellik = {
        '$value': c.total_price / 100,
        AddedItemProductName: s.product_title, AddedItemProductID: String(s.product_id), AddedItemSKU: s.sku,
        AddedItemVariantName: s.variant_title, AddedItemImageURL: s.image, AddedItemURL: o + s.url,
        AddedItemPrice: s.final_price / 100, AddedItemQuantity: s.quantity,
        ItemNames: c.items.map(function(i){ return i.product_title; }),
        CheckoutURL: o + '/checkout',
        Items: c.items.map(function(i){ return { ProductID: String(i.product_id), SKU: i.sku, ProductName: i.product_title, VariantName: i.variant_title, Quantity: i.quantity, ItemPrice: i.final_price / 100, RowTotal: i.final_line_price / 100, ProductURL: o + i.url, ImageURL: i.image }; })
      };
      var k = window.klaviyo || (window.klaviyo = []);
      try { k.push(['track', 'Added to Cart', ozellik]); } catch(e){}
    }).catch(function(){ kMesgul = false; });
  }

  /* ---------- 1b) Ürün kartlarında taksit ---------- */
  function kartlar(){
    if (!M) return;
    var bloklar = document.querySelectorAll('product-block .product-price--block:not([data-mel-tk])');
    for (var i = 0; i < bloklar.length; i++){
      var b = bloklar[i]; b.setAttribute('data-mel-tk', '1');
      var c = b.querySelector('.price__current') || b;
      var f = sayi(c.textContent);
      if (!f || f < AYAR.kartEsik) continue;
      b.appendChild(el('div', 'mel-tk-kart', '3 × ' + tl(ucte(f))));
    }
  }

  /* ---------- 1c + 3b) Sepet çekmecesi ---------- */
  var sepetImza = null, sepetVeri = null, miniHat = null;
  var CHARM = [
    { id: 53467218706797, kod: 'BP684', img: 'https://cdn.shopify.com/s/files/1/0984/2543/8573/files/urunres-34481bp68410.jpg' },
    { id: 53467219100013, kod: 'BP683', img: 'https://cdn.shopify.com/s/files/1/0984/2543/8573/files/urunres-34481bp68310.jpg' },
    { id: 53467219394925, kod: 'BP682', img: 'https://cdn.shopify.com/s/files/1/0984/2543/8573/files/urunres-34481bp68210.jpg' },
    { id: 53467219558765, kod: 'BP681', img: 'https://cdn.shopify.com/s/files/1/0984/2543/8573/files/urunres-34481bp68110.jpg' }
  ];
  var CHARM_IDS = CHARM.map(function(c){ return c.id; });
  /* Hediye eşiği: Shopify, başka ürün indirimi (ör. Anne & Kız kombini) alan satırları eşiğe saymaz; burada da sayılmaz. */
  function hediyeCiz(d, alt){
    var c = sepetVeri; if (!c) return;
    var gecerli = 0, charm = null;
    (c.items || []).forEach(function(i){
      if (CHARM_IDS.indexOf(i.variant_id) > -1){ if (!charm) charm = i; return; }
      var baska = (i.line_level_discount_allocations || []).some(function(x){ return !/hediye/i.test((x.discount_application && x.discount_application.title) || ''); });
      if (!baska) gecerli += i.final_line_price / 100;
    });
    var kalan = Math.max(0, AYAR.hediyeEsik - gecerli), oran = Math.min(100, gecerli / AYAR.hediyeEsik * 100), hh;
    if (kalan > 0){
      hh = '<div>Sepetine <b>' + tl(kalan) + '</b> daha ekle, <b>' + AYAR.hediyeAdi + '</b> hediye 🎁</div><div class="mel-hediye__bar"><i style="width:' + oran.toFixed(1) + '%"></i></div>';
    } else if (charm && charm.final_line_price === 0){
      hh = '<div>🎁 <b>' + AYAR.hediyeAdi + '</b> hediyen sepette.</div><div class="mel-hediye__bar"><i style="width:100%"></i></div>';
    } else {
      hh = '<div>Tebrikler! <b>' + AYAR.hediyeAdi + '</b> hediyeni seç 🎁</div><div class="mel-hediye__bar"><i style="width:100%"></i></div><div class="mel-secenek mel-secenek--renk" style="margin:8px 0 0">';
      CHARM.forEach(function(x){ hh += '<button type="button" data-mel-hediye="' + x.id + '" aria-label="' + x.kod + '"><img src="' + x.img + '?width=120" alt=""></button>'; });
      hh += '</div>';
    }
    var h = d.querySelector('.mel-hediye');
    if (!h){ h = el('div', 'mel-hediye'); var ust = d.querySelector('.cart-discount-list') || alt; ust.parentNode.insertBefore(h, ust); }
    h.classList.toggle('mel-hediye--tamam', kalan === 0);
    if (h.innerHTML !== hh) h.innerHTML = hh;
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-mel-hediye]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    fetch(KOK + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-mel-hediye'), 10), quantity: 1 }] }) })
      .then(function(){ sepetImza = null; document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true })); })
      .catch(function(){ b.disabled = false; });
  });
  function cekmece(){
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var alt = d.querySelector('.subtotal');
    if (alt && M){
      var toplam = sayi((alt.querySelector('.theme-money') || alt).textContent);
      var mevcut = d.querySelector('.mel-tk-sepet');
      var html = '<span>' + M.tk3 + '</span><span>' + M.aylik + ' <b>' + tl(ucte(toplam)) + '</b></span>';
      if (!mevcut){ mevcut = el('div', 'mel-tk-sepet'); alt.parentNode.insertBefore(mevcut, alt.nextSibling); }
      if (mevcut.innerHTML !== html) mevcut.innerHTML = html;
      if (AYAR.hediye && DIL === 'tr') hediyeCiz(d, alt);
    }
    if (DIL !== 'tr') return;
    var liste = d.querySelector('.cart-item-list');
    if (liste && miniHat && !d.querySelector('.mel-mini-hat')) liste.appendChild(miniHat.cloneNode(true));
    var imza = (alt ? alt.textContent : '') + '|' + d.querySelectorAll('.cart-item').length;
    if (imza === sepetImza) return; sepetImza = imza;
    sepetOku().then(function(c){
      sepetVeri = c; if (AYAR.hediye && alt) hediyeCiz(d, alt); var basliklar = c.items.map(function(i){ return String(i.product_title).toUpperCase(); });
      var aday = null;
      for (var i = 0; i < c.items.length; i++){
        var t = String(c.items[i].product_title).toUpperCase();
        if (/^MELISSA /.test(t) && basliklar.indexOf('MINI ' + t) < 0){ aday = t; break; }
      }
      var eski = d.querySelector('.mel-mini-hat');
      if (!aday){ miniHat = null; if (eski) eski.remove(); return; }
      ara('MINI ' + aday).then(function(ps){
        var p = ps.filter(function(x){ return String(x.title).toUpperCase() === 'MINI ' + aday && x.available !== false; })[0];
        var e2 = d.querySelector('.mel-mini-hat'); if (e2) e2.remove();
        if (!p){ miniHat = null; return; }
        miniHat = el('a', 'mel-mini-hat', '<img src="' + gorsel(p.image, 120) + '" alt=""><span>Mini\'si de var 👧 Birlikte alınca sepette <b>%' + AYAR.indirim + '</b> kombin indirimi. <u>Mini\'yi incele →</u></span>');
        miniHat.href = p.url;
        var l2 = d.querySelector('.cart-item-list'); if (l2) l2.appendChild(miniHat.cloneNode(true));
      });
    }).catch(function(){});
  }

  /* ---------- Ürün sayfası ---------- */
  var URUN = window.MEL_URUN || null;

  function bedenSirasi(){
    if (!URUN) return -1;
    for (var i = 0; i < URUN.secenekler.length; i++){ if (RENK.indexOf(String(URUN.secenekler[i]).toLowerCase()) < 0) return i; }
    return 0;
  }
  function seciliVaryant(){
    var f = document.querySelector('#content form.js-product-form [name="id"]') || document.querySelector('form.js-product-form [name="id"]');
    var id = f ? parseInt(f.value, 10) : 0;
    if (!id){ var m = location.search.match(/variant=(\d+)/); if (m) id = parseInt(m[1], 10); }
    for (var i = 0; i < URUN.varyantlar.length; i++) if (URUN.varyantlar[i].id === id) return URUN.varyantlar[i];
    return URUN.varyantlar[0];
  }

  /* 1a) Fiyat altı taksit */
  function pdpTaksit(v){
    if (!M) return;
    var f = document.querySelector('#content .product-info__price'); if (!f) return;
    var html = M.pesin + ' <b>3 × ' + tl(ucte(v.fiyat / 100)) + '</b>';
    var e = f.parentNode.querySelector('.mel-tk-pdp');
    if (!e){ e = el('div', 'mel-tk-pdp'); f.parentNode.insertBefore(e, f.nextSibling); }
    if (e.innerHTML !== html) e.innerHTML = html;
  }

  /* 2) Akıllı alternatif */
  var altAnahtar = null, altKutu = null;
  function altYer(){
    var bis = document.querySelector('#content .sb-kutu');
    if (bis) return { ust: bis.parentNode, sonra: bis.nextSibling };
    var form = document.querySelector('#content form.js-product-form');
    return form ? { ust: form.parentNode, sonra: form.nextSibling } : null;
  }
  function alternatif(v){
    if (DIL !== 'tr') return;
    var mevcut = document.querySelector('.mel-alt');
    if (v.stok){ if (mevcut) mevcut.remove(); altAnahtar = null; altKutu = null; return; }
    if (altAnahtar === v.id){
      if (altKutu && !mevcut){ var y0 = altYer(); if (y0) y0.ust.insertBefore(altKutu, y0.sonra); }
      return;
    }
    altAnahtar = v.id; altKutu = null; if (mevcut) mevcut.remove();
    var bi = bedenSirasi(), beden = v.sec[bi], anahtar = v.id;
    var kardes = ara(URUN.baslik).then(function(ps){
      ps = ps.filter(function(x){ return x.title === URUN.baslik && taban(x.url) === taban(location.pathname) && hdl(x.url) !== URUN.handle; }).slice(0, 6);
      return Promise.all(ps.map(function(x){ return urunJs(hdl(x.url)); }));
    }).then(function(js){
      var o = [];
      js.forEach(function(p){ if (!p) return; var vv = p.variants.filter(function(z){ return z.available && z.options[bi] === beden; })[0]; if (vv) o.push({ url: KOK + '/products/' + p.handle + '?variant=' + vv.id, img: p.featured_image, kod: (p.handle.split('-').pop() || '').toUpperCase() }); });
      return o;
    });
    var benzer = fetch(KOK + '/recommendations/products.json?product_id=' + URUN.id + '&limit=12&intent=related').then(function(r){ return r.json(); }).then(function(d){
      var o = [], goruldu = {};
      (d.products || []).forEach(function(p){
        if (o.length >= 3 || p.title === URUN.baslik || goruldu[p.title]) return;
        var bj = biOf(p), vv = p.variants.filter(function(z){ return z.available && z.options[bj] === beden; })[0];
        if (!vv) return; goruldu[p.title] = 1;
        o.push({ url: KOK + '/products/' + p.handle + '?variant=' + vv.id, img: p.featured_image, ad: p.title.replace(/^MELISSA /i, '').replace(/^MINI MELISSA /i, 'Mini '), fiyat: vv.price / 100, eski: vv.compare_at_price && vv.compare_at_price > vv.price ? vv.compare_at_price / 100 : 0 });
      });
      return o;
    }).catch(function(){ return []; });
    Promise.all([kardes, benzer]).then(function(r){
      if (altAnahtar !== anahtar) return;
      var k = r[0], b = r[1]; if (!k.length && !b.length) return;
      var h = '<p class="mel-baslik">Bu renkte ' + kes(beden) + ' numara kalmadı</p>';
      if (k.length){
        h += '<p class="mel-etiket">Aynı model, ' + kes(beden) + ' numara stokta</p><div class="mel-renkler">';
        k.forEach(function(x){ h += '<a class="mel-renk" href="' + x.url + '"><img src="' + gorsel(x.img, 200) + '" alt="" loading="lazy">' + kes(x.kod) + '</a>'; });
        h += '</div>';
      }
      if (b.length){
        h += '<p class="mel-etiket">' + kes(beden) + ' numarada şu an stokta</p><div class="mel-izgara">';
        b.forEach(function(x){ h += '<a class="mel-kart" href="' + x.url + '"><img src="' + gorsel(x.img, 300) + '" alt="" loading="lazy"><div class="mel-kart__ad">' + kes(x.ad) + '</div><div class="mel-kart__fiyat">' + tl(x.fiyat) + (x.eski ? '<s>' + tl(x.eski) + '</s>' : '') + '</div></a>'; });
        h += '</div>';
      }
      altKutu = el('div', 'mel-kutu mel-alt', h);
      var y = altYer(); if (y) y.ust.insertBefore(altKutu, y.sonra);
    });
  }

  /* 3) Anne & Kız kombini */
  var ak = { hazir: false, adaylar: [], aday: 0, varyant: null, kutu: null };
  function akYukle(){
    if (DIL !== 'tr' || !URUN) return;
    var hedef = hedefBaslik(URUN.baslik); if (!hedef) return;
    ara(hedef).then(function(ps){
      ps = ps.filter(function(x){ return String(x.title).toUpperCase() === hedef.toUpperCase(); }).slice(0, 4);
      return Promise.all(ps.map(function(x){ return urunJs(hdl(x.url)); }));
    }).then(function(js){
      ak.adaylar = js.filter(function(p){ return p && !(p.compare_at_price_max > p.price) && p.variants.some(function(z){ return z.available; }); });
      if (!ak.adaylar.length) return;
      ak.hazir = true; akCiz(); if (bc.kutu) bc.kutu.style.display = 'none';
    });
  }
  function akCiz(){
    if (!ak.hazir) return;
    var mini = /^MINI /i.test(URUN.baslik);
    var p = ak.adaylar[ak.aday], bi = biOf(p);
    var vAna = seciliVaryant();
    if (ak.varyant && !p.variants.some(function(z){ return z.id === ak.varyant && z.available; })) ak.varyant = null;
    var vMini = ak.varyant ? p.variants.filter(function(z){ return z.id === ak.varyant; })[0] : null;
    var h = '<span class="mel-pill">ANNE &amp; KIZ</span>';
    h += '<p class="mel-baslik" style="margin-bottom:6px">' + (mini ? 'Annesi için de var.' : 'Mini\'si de var.') + ' Birlikte alınca sepette %' + AYAR.indirim + ' kombin indirimi.</p>';
    h += '<div class="mel-ak__satir"><img src="' + (String(URUN.gorsel).indexOf('//') === 0 ? 'https:' + URUN.gorsel : URUN.gorsel) + '" alt=""><span class="mel-ak__arti">+</span><img src="' + gorsel(p.featured_image, 200) + '" alt=""><div class="mel-ak__ad">' + kes(p.title) + '<span>' + tl(p.price / 100) + '</span></div></div>';
    if (ak.adaylar.length > 1){
      h += '<p class="mel-etiket">Renk</p><div class="mel-secenek mel-secenek--renk">';
      ak.adaylar.forEach(function(a, i){ h += '<button type="button" data-ak-renk="' + i + '" aria-pressed="' + (i === ak.aday) + '" aria-label="' + kes(a.handle) + '"><img src="' + gorsel(a.featured_image, 120) + '" alt=""></button>'; });
      h += '</div>';
    }
    h += '<p class="mel-etiket">' + (mini ? 'Anne numarası' : 'Mini numarası') + '</p><div class="mel-secenek">';
    p.variants.forEach(function(z){ h += '<button type="button" data-ak-var="' + z.id + '" aria-pressed="' + (z.id === ak.varyant) + '"' + (z.available ? '' : ' disabled') + '>' + kes(z.options[bi] || z.title) + '</button>'; });
    h += '</div>';
    var ana = vAna.fiyat / 100, ek = vMini ? vMini.price / 100 : p.price / 100;
    var top = ana + ek, kaz = Math.round(Math.max(ana, ek) * AYAR.indirim) / 100, ind = Math.round((top - kaz) * 100) / 100;
    h += '<div class="mel-ak__toplam"><div><s>' + tl(top) + '</s><b>' + tl(ind) + '</b></div><span>3 × ' + tl(ucte(ind)) + '</span></div>';
    h += '<p class="mel-not" style="margin:-4px 0 10px;text-align:left">Kombin indirimi: <b style="color:#111">−' + tl(kaz) + '</b></p>';
    var hazir = vAna.stok && vMini;
    var yazi = !vAna.stok ? 'Önce numaranı seç' : (!vMini ? (mini ? 'Anne numarasını seç' : 'Mini numarasını seç') : 'İkisini birden sepete ekle');
    h += '<button type="button" class="mel-btn" data-ak-ekle' + (hazir ? '' : ' disabled') + '>' + yazi + '</button>';
    h += '<p class="mel-not">%' + AYAR.indirim + ' indirim, kombindeki yüksek tutarlı ürüne sepette otomatik uygulanır.</p>';
    if (!ak.kutu){
      ak.kutu = el('div', 'mel-kutu mel-ak');
      ak.kutu.addEventListener('click', function(e){
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        if (b.hasAttribute('data-ak-renk')){ ak.aday = parseInt(b.getAttribute('data-ak-renk'), 10); ak.varyant = null; akCiz(); }
        else if (b.hasAttribute('data-ak-var')){ ak.varyant = parseInt(b.getAttribute('data-ak-var'), 10); akCiz(); }
        else if (b.hasAttribute('data-ak-ekle')){ akEkle(b); }
      });
    }
    ak.kutu.innerHTML = h;
    ak.kutu.style.display = (vAna.eski > vAna.fiyat) ? 'none' : '';
    akYerlestir();
  }
  function akYerlestir(){
    if (!ak.kutu || document.body.contains(ak.kutu)) return;
    var form = document.querySelector('#content form.js-product-form');
    if (form && form.parentNode) form.parentNode.insertBefore(ak.kutu, form.nextSibling);
  }
  function akEkle(b){
    var vAna = seciliVaryant(); if (!vAna.stok || !ak.varyant) return;
    b.disabled = true; b.textContent = 'Ekleniyor…';
    fetch(KOK + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vAna.id, quantity: 1 }, { id: ak.varyant, quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw new Error('ekleme'); return r.json(); })
      .then(function(){
        b.textContent = 'Sepete eklendi ✓';
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true })); klaviyoIzle();
        var d = document.querySelector('cart-drawer');
        setTimeout(function(){ try { if (d && typeof d.open === 'function') d.open(); else if (d && typeof d.show === 'function') d.show(); } catch(e){} }, 300);
        setTimeout(akCiz, 2500);
      })
      .catch(function(){ b.textContent = 'Eklenemedi, tekrar deneyin'; setTimeout(akCiz, 2500); });
  }

  /* 5) Bot + Çanta kombini (TASLAK) */
  var bc = { yuklendi: false, liste: [], secili: 0, kutu: null, tur: null };
  function bcTur(){
    if (!URUN || DIL !== 'tr' || /^MINI /i.test(URUN.baslik)) return null;
    var t = (URUN.etiketler || []).map(function(x){ return String(x).toUpperCase(); });
    if (t.indexOf('BOT / ÇİZME') > -1) return 'bot';
    if (t.indexOf('ÇANTA') > -1) return 'canta';
    return null;
  }
  function bcYukle(){
    bc.tur = bcTur(); if (!bc.tur) return;
    var kol = bc.tur === 'bot' ? 'cantalar' : 'bot';
    fetch(KOK + '/collections/' + kol + '/products.json?limit=60').then(function(r){ return r.json(); }).then(function(d){
      var gor = {};
      bc.liste = (d.products || []).filter(function(p){
        if (p.handle === URUN.handle || /^MINI /i.test(p.title) || gor[p.title]) return false;
        var uygun = p.variants.some(function(v){ return v.available && !(v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)); });
        if (uygun) gor[p.title] = 1;
        return uygun;
      }).slice(0, 3);
      if (!bc.liste.length) return;
      bc.yuklendi = true; bcCiz();
    }).catch(function(){});
  }
  function bcCiz(){
    if (!bc.yuklendi || ak.hazir) { if (bc.kutu) bc.kutu.style.display = 'none'; return; }
    var vAna = seciliVaryant(), h = '<span class="mel-pill" style="background:#dfe6da">BOT + ÇANTA</span>';
    if (bc.tur === 'bot'){
      h += '<p class="mel-baslik" style="margin-bottom:10px">Kombini tamamla. Botla birlikte alınca çantada %' + AYAR.bcIndirim + ' indirim.</p><div class="mel-bc__liste">';
      bc.liste.forEach(function(p, i){
        var v = p.variants.filter(function(z){ return z.available; })[0], f = parseFloat(v.price), y = Math.round(f * (100 - AYAR.bcIndirim)) / 100;
        h += '<button type="button" class="mel-bc__kart" data-bc="' + i + '" aria-pressed="' + (i === bc.secili) + '"><img src="' + gorsel(p.images && p.images[0] && p.images[0].src, 240) + '" alt=""><div class="mel-bc__ad">' + kes(p.title.replace(/^MELISSA /i, '')) + '</div><div class="mel-bc__fiyat"><s>' + tl(f) + '</s><b>' + tl(y) + '</b></div></button>';
      });
      h += '</div>';
      var cv = bc.liste[bc.secili].variants.filter(function(z){ return z.available; })[0];
      var ana = vAna.fiyat / 100, cf = parseFloat(cv.price), kaz = Math.round(cf * AYAR.bcIndirim) / 100, top = ana + cf, ind = Math.round((top - kaz) * 100) / 100;
      h += '<div class="mel-ak__toplam"><div><s>' + tl(top) + '</s><b>' + tl(ind) + '</b></div><span>3 × ' + tl(ucte(ind)) + '</span></div>';
      h += '<button type="button" class="mel-btn" data-bc-ekle' + (vAna.stok ? '' : ' disabled') + '>' + (vAna.stok ? 'Botla birlikte sepete ekle' : 'Önce numaranı seç') + '</button>';
      h += '<p class="mel-not">%' + AYAR.bcIndirim + ' indirim çantaya sepette otomatik uygulanır.</p>';
    } else {
      h += '<p class="mel-baslik" style="margin-bottom:10px">Bu çanta bir botla daha güzel. Bot ile birlikte alınca çantada %' + AYAR.bcIndirim + ' indirim.</p><div class="mel-bc__liste">';
      bc.liste.forEach(function(p){ var v = p.variants.filter(function(z){ return z.available; })[0]; h += '<a class="mel-bc__kart" href="' + KOK + '/products/' + p.handle + '"><img src="' + gorsel(p.images && p.images[0] && p.images[0].src, 240) + '" alt=""><div class="mel-bc__ad">' + kes(p.title.replace(/^MELISSA /i, '')) + '</div><div class="mel-bc__fiyat">' + tl(parseFloat(v.price)) + '</div></a>'; });
      h += '</div><p class="mel-not" style="text-align:left">Çantayı ve botu sepete ekle; %' + AYAR.bcIndirim + ' indirim çantaya otomatik uygulanır.</p>';
    }
    if (!bc.kutu){
      bc.kutu = el('div', 'mel-kutu mel-ak');
      bc.kutu.addEventListener('click', function(e){
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        if (b.hasAttribute('data-bc')){ bc.secili = parseInt(b.getAttribute('data-bc'), 10); bcCiz(); }
        else if (b.hasAttribute('data-bc-ekle')){ bcEkle(b); }
      });
    }
    bc.kutu.innerHTML = h; bc.kutu.style.display = '';
    if (!document.body.contains(bc.kutu)){ var form = document.querySelector('#content form.js-product-form'); if (form && form.parentNode) form.parentNode.insertBefore(bc.kutu, form.nextSibling); }
  }
  function bcEkle(b){
    var vAna = seciliVaryant(); if (!vAna.stok) return;
    var cv = bc.liste[bc.secili].variants.filter(function(z){ return z.available; })[0];
    b.disabled = true; b.textContent = 'Ekleniyor…';
    fetch(KOK + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vAna.id, quantity: 1 }, { id: cv.id, quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw new Error('ekleme'); return r.json(); })
      .then(function(){
        b.textContent = 'Sepete eklendi ✓';
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true })); klaviyoIzle();
        var d = document.querySelector('cart-drawer');
        setTimeout(function(){ try { if (d && typeof d.open === 'function') d.open(); } catch(e){} }, 300);
        setTimeout(bcCiz, 2500);
      })
      .catch(function(){ b.textContent = 'Eklenemedi, tekrar deneyin'; setTimeout(bcCiz, 2500); });
  }

  /* 6) Arama: kategori yönlendirme bandı + sonuçsuz aramada çok satanlar */
  var ARAMA = [
    { k: ['bot', 'botlar', 'bota', 'cizme', 'çizme', 'yagmur botu', 'yağmur botu', 'kar botu', 'kadin bot', 'kadın bot', 'boot'], ad: 'Bot & Çizme', url: '/collections/bot' },
    { k: ['babet', 'babetler', 'balerin', 'ballerina', 'duz ayakkabi', 'düz ayakkabı'], ad: 'Babetler', url: '/collections/babet' },
    { k: ['jole', 'jöle', 'jelly', 'plastik ayakkabi', 'plastik ayakkabı', 'kokulu ayakkabi', 'kokulu ayakkabı'], ad: 'Tüm Melissa jelly ayakkabılar', url: '/collections/melissa' },
    { k: ['terlik', 'terlikler', 'parmak arasi', 'parmak arası', 'flip flop', 'sipidik', 'şıpıdık', 'slide'], ad: 'Terlikler', url: '/collections/terlik' },
    { k: ['sandalet', 'sandaletler'], ad: 'Sandaletler', url: '/collections/sandalet' },
    { k: ['spor ayakkabi', 'spor ayakkabı', 'sneaker', 'sneakers', 'spor'], ad: 'Sneaker & Spor Ayakkabı', url: '/collections/spor-ayakkabi' },
    { k: ['topuklu', 'topuk', 'topuklu ayakkabi', 'topuklu ayakkabı', 'heel'], ad: 'Topuklu Ayakkabılar', url: '/collections/topuklu-ayakkabi' },
    { k: ['canta', 'çanta', 'cantalar', 'çantalar', 'bag'], ad: 'Çantalar', url: '/collections/cantalar' },
    { k: ['mini', 'cocuk', 'çocuk', 'kiz cocuk', 'kız çocuk', 'bebek', 'kids', 'mini melissa'], ad: 'Mini Melissa', url: '/collections/mini-melissa' },
    { k: ['platform'], ad: 'Platform', url: '/collections/platform' },
    { k: ['charm', 'anahtarlik', 'anahtarlık', 'hediye', 'aksesuar'], ad: 'Charm & Aksesuar', url: '/collections/charm' },
    { k: ['indirim', 'sale', 'outlet', 'kampanya', 'firsat', 'fırsat'], ad: 'İndirimli ürünler', url: '/collections/ozel-fiyatlar' }
  ];
  function normal(t){ return String(t || '').toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim(); }
  var araldi = false;
  function arama(){
    if (DIL !== 'tr' || araldi || location.pathname.indexOf('/search') < 0) return;
    var q = normal(new URLSearchParams(location.search).get('q')); if (!q) return;
    var main = document.querySelector('#content'); if (!main) return;
    var h1 = main.querySelector('h1'); if (!h1) return;
    araldi = true;
    var ust = h1.closest('.container, .page-header, header, section') || h1.parentNode;
    var esles = null;
    ARAMA.forEach(function(g){ if (!esles && g.k.some(function(k){ return q === k || q.indexOf(k + ' ') === 0 || q.slice(-k.length - 1) === ' ' + k; })) esles = g; });
    if (esles){
      var a = el('a', 'mel-ara', '<span>Aradığın bu olabilir: <b>' + esles.ad + '</b></span><span>Koleksiyona git →</span>');
      a.href = KOK + esles.url; ust.appendChild(a);
    }
    var sonuc = main.querySelectorAll('product-block').length;
    if (sonuc > 0) return;
    var bos = el('div', 'mel-bos container', '<p class="mel-baslik" style="font-size:18px">Aradığını bulamadın mı? Bunlara göz at:</p><div class="mel-bos__cipler">' +
      ['Bot & Çizme|/collections/bot', 'Babet|/collections/babet', 'Sneaker|/collections/spor-ayakkabi', 'Sandalet|/collections/sandalet', 'Çanta|/collections/cantalar', 'Mini Melissa|/collections/mini-melissa', 'İndirim|/collections/ozel-fiyatlar'].map(function(x){ var p = x.split('|'); return '<a href="' + KOK + p[1] + '">' + p[0] + '</a>'; }).join('') +
      '</div><p class="mel-etiket">Çok satanlar</p><div class="mel-bos__izgara"></div>');
    ust.insertAdjacentElement('afterend', bos);
    fetch(KOK + '/collections/cok-satanlar/products.json?limit=12').then(function(r){ return r.json(); }).then(function(d){
      var g = bos.querySelector('.mel-bos__izgara'), n = 0;
      (d.products || []).forEach(function(p){
        if (n >= 8) return; var v = p.variants.filter(function(z){ return z.available; })[0]; if (!v) return; n++;
        var f = parseFloat(v.price), e = v.compare_at_price && parseFloat(v.compare_at_price) > f ? parseFloat(v.compare_at_price) : 0;
        g.insertAdjacentHTML('beforeend', '<a class="mel-kart" href="' + KOK + '/products/' + p.handle + '"><img src="' + gorsel(p.images && p.images[0] && p.images[0].src, 400) + '" alt="" loading="lazy"><div class="mel-kart__ad">' + kes(p.title.replace(/^MELISSA /i, '')) + '</div><div class="mel-kart__fiyat">' + tl(f) + (e ? '<s>' + tl(e) + '</s>' : '') + '</div><div class="mel-tk-kart">3 × ' + tl(ucte(f)) + '</div></a>');
      });
    }).catch(function(){});
  }

  /* ---------- çalıştırıcı ---------- */
  var sonVaryant = null;
  function pdp(){
    if (!URUN) return;
    var v = seciliVaryant();
    pdpTaksit(v);
    alternatif(v);
    if (ak.hazir){ akYerlestir(); if (sonVaryant !== v.id) akCiz(); }
    if (bc.yuklendi && (sonVaryant !== v.id || (bc.kutu && !document.body.contains(bc.kutu)))) bcCiz();
    sonVaryant = v.id;
  }
  function hepsi(){ try { kartlar(); } catch(e){} try { pdp(); } catch(e){} try { cekmece(); } catch(e){} try { arama(); } catch(e){} }
  function baslat(){
    hepsi(); akYukle(); bcYukle(); klaviyoIzle();
    var kt = tutucu(klaviyoIzle, 600);
    ['on:cart:change', 'on:cart:after-merge', 'on:cart:add', 'cart:updated'].forEach(function(o){ document.addEventListener(o, kt); });
    var t = tutucu(hepsi, 120);
    try { new MutationObserver(t).observe(document.body, { childList: true, subtree: true }); } catch(e){}
    ['change', 'variant:change', 'on:variant:change', 'on:cart:change', 'on:cart:after-merge'].forEach(function(o){ document.addEventListener(o, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat); else baslat();
})();
